import { JobRepairUpdatableInterface } from '../interfaces/job-repair-updatable.interface';
import { JobRepairDto } from './job-repair.dto';
import { ApiPropertyOptional, PartialType, PickType } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { JobRepairBuilderSupervisorBatchDto } from '../../job-repair-builder-supervisor/dto/job-repair-builder-supervisor-batch.dto';

export class JobRepairUpdateDto
  extends PartialType(
    PickType(JobRepairDto, [
      'repairId',
      'jobId',
      'repairDate',
      'poTotalOverride',
      'internalInvoice',
      'readyToBook',
      'poReleased',
    ]),
  )
  implements JobRepairUpdatableInterface
{
  @ApiPropertyOptional({
    type: () => [JobRepairBuilderSupervisorBatchDto],
    title: 'Subdivision builder supervisor batch dto',
    description:
      'Subdivision builder supervisor associated with this job repair',
  })
  @Expose()
  subdivisionBuilderSupervisor!: JobRepairBuilderSupervisorBatchDto;
}
